module.exports = __webpack_public_path__ + "img/IMG_1645_Wood_MockedUp.ee483e00.jpg";